import Confirmation from "./Confirmation";
import Signup from "./Signup";

const pages = {
  Main: Signup,
  Confirmation,
};
export default pages;
